import i18n from "@shared/plugins/i18n";

export const getPermissionErrorMessages = () =>  ({
  "checkOutput.detailed_card": i18n.t('errors.permissions.checkOutput.detailed_card'),
  "case.run_check": i18n.t('errors.permissions.case.run_check'),
  "case.edit": i18n.t('errors.permissions.case.edit'),
})